import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IVehicleSearch, IVehicleDetail, IVehicleFields } from "./vehicleType"
export interface paramsDisable {
    id: string,
    enable: number
}

class VehicleService {
    async page(searchVo: IVehicleSearch) {
        const apiUrl = "/vrm-sa/base/vehicle/findPage";
        return await httpRequest.post<IPage<IVehicleDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/base/vehicle/findById/${id}`;
        return await httpRequest.get<IVehicleDetail>(apiUrl);
    }
    async insert(insertVo: IVehicleFields) {
        const apiUrl = "/vrm-sa/base/vehicle/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IVehicleFields) {
        const apiUrl = "/vrm-sa/base/vehicle/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // //启用禁用
    // async disable(id: string, status: number) {
    //     const apiUrl = `/vrm-sa/base/vehicle/enableOrDisable/${id}/${status}`;
    //     return await httpRequest.get<boolean>(apiUrl);
    // }
    //启用禁用
    async disable(params: paramsDisable) {
        const apiUrl = `/vrm-sa/base/vehicle/change`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/vrm-sa/base/vehicle/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IVehicleSearch) {
        const appPageUrl = "/vrm-sa/base/vehicle/export";
        return await httpRequest.postFile(appPageUrl, searchVo,{ timeout: 600000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/vrm-sa/base/vehicle/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
}
export const vehicleService = new VehicleService();